"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AUTHENTICATION_RESTORE_TYPE = exports.AUTHENTICATION_RESET_TYPE = exports.AUTHENTICATION_CHECK_EMAIL_TYPE = exports.AUTHENTICATION_CHANGE_VIEW_TYPE = exports.AUTHENTICATION_CHANGE_PASSWORD_TYPE = exports.AUTHENTICATION_AUTHENTICATE_TYPE = void 0;
const AUTHENTICATION_CHECK_EMAIL_TYPE = exports.AUTHENTICATION_CHECK_EMAIL_TYPE = 'authentication/checkEmail/status_changed';
const AUTHENTICATION_AUTHENTICATE_TYPE = exports.AUTHENTICATION_AUTHENTICATE_TYPE = 'authentication/authenticate/status_changed';
const AUTHENTICATION_RESTORE_TYPE = exports.AUTHENTICATION_RESTORE_TYPE = 'authentication/restore/status_changed';
const AUTHENTICATION_CHANGE_VIEW_TYPE = exports.AUTHENTICATION_CHANGE_VIEW_TYPE = 'authentication/changeView';
const AUTHENTICATION_CHANGE_PASSWORD_TYPE = exports.AUTHENTICATION_CHANGE_PASSWORD_TYPE = 'authentication/changePassword';
const AUTHENTICATION_RESET_TYPE = exports.AUTHENTICATION_RESET_TYPE = 'authentication/reset';